<template>
  <div class="addClassDialog">
    <div class="btnview">
      <el-button
        class="addclass"
        size="small"
        type="text"
        plain
        @click="openDialog"
        >选择班级</el-button
      >
    </div>
    <el-dialog
      title="选择报名班级"
      :visible.sync="addClassDialogVisible"
      width="80%"
      top="10vh"
      append-to-body
    >
      <div class="dialog-body">
        <el-form
          size="small"
          :inline="true"
          class="form-style"
          ref="form"
          :model="form"
        >
          <el-form-item label="授课类型" prop="teaching_type">
            <el-select
              v-model="form.teaching_type"
              @change="getCampusCurriculumtList"
            >
              <el-option label="面授课" :value="1"></el-option>
              <el-option label="直播课" :value="2"></el-option>
              <el-option label="录播课" :value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="学科" prop="subject_id">
            <el-select
              :disabled="form.teaching_type === ''"
              v-model="form.subject_id"
              @change="getCampusCurriculumtList"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) of subjectList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="课程体系" required prop="curriculum_id">
            <el-select
              v-model="form.curriculum_id"
              @change="getCampusTeacherList"
              :disabled="!form.subject_id"
            >
              <el-option
                :label="item.title"
                :value="item.id"
                v-for="(item, index) of curriculum_list"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="班级状态">
            <el-select v-model="form.course_state">
              <el-option label="已开课班级" :value="1"></el-option>
              <el-option label="待开课班级" :value="2"></el-option>
              <el-option label="待排课班级" :value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="班级名称">
            <el-input
              placeholder="请输入内容"
              v-model="form.search_value"
              class="input-with-select"
            >
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="search" type="primary">搜索</el-button>
            <el-button @click="reSize('form')">重置</el-button>
          </el-form-item>
        </el-form>

        <el-table
          size="small"
          ref="classTable"
          :data="tableData"
          tooltip-effect="dark"
          highlight-current-row
          @current-change="handleCurrentClass"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column
            fixed="left"
            width="150"
            label="班级名称"
            prop="name"
          ></el-table-column>
          <el-table-column label="科目" prop="subject_name"></el-table-column>
          <el-table-column
            width="150"
            label="体系名称"
            prop="curriculum_name"
          ></el-table-column>
          <el-table-column width="300" label="开课/结课">
            <template slot-scope="scope">
              {{ scope.row.start_date }} /
              {{ scope.row.end_date }}
            </template>
          </el-table-column>

          <el-table-column width="200" label="授课时段">
            <template slot-scope="scope">
              {{ scope.row.week_str }} /
              {{ scope.row.time_str }}
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            prop="lecturer_nickname"
            label="上课老师"
          ></el-table-column>

          <el-table-column
            width="150"
            prop="student_total_num"
            label="学员数"
          ></el-table-column>
        </el-table>

        <div style="margin-top: 30px; text-align: right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page_no"
            :page-size="20"
            layout="total,prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quit">取消</el-button>
        <el-button size="small" type="primary" @click="confirmTo"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getClassList,
  getCurriculumList,
  getUserTeacher,
  getNormalClassesList,
  getCampusSubjectList,
  getCampusCurriculumtList,
  getClassesList,
} from "@/api/educational";
export default {
  name: "addformalClassDialog",
  props: {
    campusId: String,
  },
  data() {
    return {
      ruleForm: {},

      form: {
        search_type: "1",
        search_value: "",
        subject_id: "",
        curriculum_id: "",
        teaching_type: "",
        course_state: "",
        page_no: "1",
        page_size: "20",
        class_date: [],
      },
      curriculum_list: [],

      addClassDialogVisible: false,
      search_value: "",
      search_type: "1",
      curriculum_id: "",
      lecturer_id: "",
      teacherList: [],

      subjectList: [],
      teacher: "",
      tableData: [],
      total: 0,
      page_no: 1,
      chooseClassList: {},
    };
  },

  methods: {
    //获取学校科目权限列表
    getCampusSubjectList() {
      console.log("校区ID");
      console.log(this.campusId);
      getCampusSubjectList({
        campusId: this.campusId,
      }).then((res) => {
        this.subjectList = res.campusSubjectList;
        console.log("获取学校科目权限列表");
        console.log(res);
      });
    },

    //获取学校公开课课程体系
    getCampusCurriculumtList() {
      console.log("this.form.subject_id");
      console.log(this.form.subject_id);

      this.curriculum_list = [];
      this.form.curriculum_id = "";

      if (!this.form.subject_id) {
        console.log("请选择科目");
        return;
      }
      getCampusCurriculumtList({
        campusId: this.campusId,
        subjectId: this.form.subject_id,
        teaching_type: this.form.teaching_type,
        class_type: "1",
      }).then((res) => {
        console.log("获取学校常规课课程体系");
        console.log(res);
        this.curriculum_list = res.campusCurriculumList;
      });
    },

    // 获取班级列表
    getClassesList() {
      getClassesList({
        educational_institution_campus_id: this.campusId,
        curriculum_class_type: "1",
        search_type: this.form.search_type,
        search_value: this.form.search_value,
        subject_id: this.form.subject_id,
        curriculum_id: this.form.curriculum_id,
        teaching_type: this.form.teaching_type,
        course_state: this.form.course_state,
        page_no: "1",
        page_size: "20",
      }).then((res) => {
        this.tableData = res.class_list;
        this.total = res.total;

        console.log("查询班级列表");
        console.log(res);
      });
    },

    //查询所有试听班级
    getNormalClassesList() {
      getNormalClassesList({
        search_type: this.form.search_type, //(1班级名称，2班级码，3教师姓名)
        search_value: this.form.search_value, //搜索值
        subject_id: this.form.subject_id, //科目
        curriculum_id: this.form.curriculum_id, //体系
        teaching_type: this.form.teaching_type,
        course_state: this.form.course_state, //（全部 空，1已开课班级，2待开课班级，3已结课班级，4待排课班级）
        class_start_time: this.form.class_date[0], //开课时间
        class_end_time: this.form.class_date[1], //结课时间
        page_no: this.form.page_no,
        page_size: this.form.page_size,
      }).then((res) => {
        this.tableData = res.class_list;
        this.total = res.class_list.length;
      });
    },

    getUserTeacher() {
      getUserTeacher().then((res) => {
        this.teacherList = res.user_list;
        console.log("所有老师");
        console.log(res);
      });
    },
    openDialog() {
      if (!this.campusId) {
        console.log("请选择校区ID");
        this.$message.warning("请选择需要交费的学员");
      } else {
        this.addClassDialogVisible = true;
        this.getCampusSubjectList();
        this.getClassesList();
      }
    },
    search() {
      console.log(this.form);
      this.getClassesList(); //获取所有试听班级
    },
    reset() {
      this.form = {
        search_type: "",
        search_value: "",
        subject_id: "",
        curriculum_id: "",
        teaching_type: "",
        course_state: "",
        page_no: "1",
        page_size: "20",
        class_date: [],
      };
      this.getNormalClassesList(); //获取所有试听班级
    },
    handleCurrentChange(val) {
      console.log(val);
    },

    handleCurrentClass(val) {
      console.log(val);
      this.chooseClassList = val;
    },

    // 获取课程体系
    getCurriculumList() {
      getCurriculumList({
        subject_id: this.subject_id,
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        this.curriculum_list = res.curriculum_list;
      });
    },
    // 获取班级列表
    getClassList() {
      getClassList({
        search_type: this.search_type,
        search_value: this.search_value,
        subject_id: this.subject_id,
        lecturer_id: this.lecturer_id,
        curriculum_id: this.curriculum_id,
        page_no: this.page_no,
      }).then((res) => {
        this.tableData = res.class_list;
        this.total = res.total;
      });
    },

    quit() {
      this.search_value = "";
      this.teacher = "";
      this.curriculum_id = "";
      this.subject_id = "";
      this.addClassDialogVisible = false;
    },
    // 确认导入
    confirmTo() {
      this.$emit("chooseClass", this.chooseClassList);
      this.quit();
    },
  },
};
</script>

<style scoped lang="scss">
.addClassDialog {
  .btnview {
    text-align: left;
    .addclass {
      margin-bottom: 20px;
    }
  }
}
</style>